import React, { ReactElement, useState, useEffect } from 'react'
import { Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import DiffComp from '@/pages/table2Mana/components/diffComp'
import { getProjectInfoById } from '@/services/table.service'

export default function LogViewDetailPop ( { recordId, show, hide, record }: {
    recordId: number | null, show: boolean, hide: any, record: any
}): ReactElement {
    const { t } = useTranslation()
    const [formDataObj, setFormDataObj] = useState<any>(null)
    
    const closePop = () => {
        hide()
    }
    const getLogDetail = async (id: number) => {
        const res = await getProjectInfoById(id)
        console.log('getLogDetail: ', res)
        setFormDataObj({
            ...record,
            techProject: res,
            changeFields: record.details
        })
    }

    useEffect(() => {
        if (recordId) {
            console.log('recordId: ', recordId)
            console.log('record: ', record)
            getLogDetail(record.associatedId)
        }
    }, [recordId])
    return (
        <Modal title={t('Modify Log')} visible={show} 
            onOk={closePop}
            onCancel={closePop}
            width='90%'
            centered
            footer={[
                <Button key="submit" type="primary" onClick={closePop}>{t('close')}</Button>
            ]}
        >
            {formDataObj && <DiffComp dataObj={formDataObj} />}
        </Modal>
    )
}